import { render } from "./ApprovedLeeds.vue?vue&type=template&id=47c12fa2&scoped=true"
import script from "./ApprovedLeeds.vue?vue&type=script&lang=js"
export * from "./ApprovedLeeds.vue?vue&type=script&lang=js"

import "./ApprovedLeeds.vue?vue&type=style&index=0&id=47c12fa2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c12fa2"]])

export default __exports__